(function () {
  // Filter links, the sort dropdown, and pagination are all full-page
  // navigations. Save the exact scroll position right before navigating
  // away and restore it here on the next load, so picking a filter doesn't
  // reset the shopper to the top of the page. A URL-fragment anchor was
  // tried instead of this (landing at a fixed spot near the results) but
  // that forces a scroll even when the shopper was already at the top,
  // which is its own unwanted jump — restoring the literal prior position
  // avoids moving them at all when no move is actually needed.
  var SCROLL_STORAGE_KEY = "collectionScrollY";
  var savedScrollY = sessionStorage.getItem(SCROLL_STORAGE_KEY);
  if (savedScrollY !== null) {
    window.scrollTo(0, parseFloat(savedScrollY));
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
  }

  // Mirrors assets/faq-accordion.js's height-measuring transition pattern —
  // replaces the old <details>/<summary> instant snap with the same
  // animated toggle used elsewhere on the site. The toggle button itself is
  // only shown <=900px (theme.css); above that the panel just starts open
  // and stays open, since nothing ever clicks the (hidden) toggle.
  const panel = document.querySelector("[data-collection-filters]");
  if (!panel) return;
  const toggle = panel.querySelector("[data-collection-filters-toggle]");
  const wrap = panel.querySelector("[data-collection-filters-body-wrap]");
  if (!toggle || !wrap) return;

  // The markup renders collapsed, which is the wanted state on mobile
  // (<=900px): the toggle is visible there, and starting open would bury
  // the product grid under a screenful of filters. Nothing to do in that
  // case — theme.css holds the panel at height 0 until the first toggle
  // click, and leaving the height purely to CSS means a resize back past
  // 900px can't strand the panel closed with no visible toggle to reopen
  // it.
  //
  // Above 900px the toggle is hidden, so the panel has to be forced open
  // here or the filters would be unreachable. Matched to the CSS as its
  // exact complement rather than a hardcoded 901px, so a fractional
  // viewport width can't fall between the two and satisfy neither.
  //
  // Deliberately `auto` rather than a snapshot pixel value: a fixed
  // snapshot can't tell that a filter group opened inside it later and
  // needs more room, and silently clips it (this bit Holiday worst, being
  // the lowest group with the least slack below it). `auto` sizes to
  // current content on every layout pass for free, so a group
  // opening/closing inside it is picked up automatically with no JS
  // involved. The only time this needs to become a concrete pixel value at
  // all is around the open/close click below, since a CSS transition can't
  // animate to/from `auto`.
  if (!window.matchMedia("(max-width: 900px)").matches) {
    toggle.setAttribute("aria-expanded", "true");
    panel.classList.add("is-open");
    wrap.style.height = "auto";
  }

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      toggle.setAttribute("aria-expanded", "false");
      panel.classList.remove("is-open");
      // Pin to the current rendered height first — can't transition away
      // from `auto` directly, only between two concrete pixel values.
      wrap.style.height = `${wrap.getBoundingClientRect().height}px`;
      void wrap.offsetHeight;
      wrap.style.height = "0px";
    } else {
      toggle.setAttribute("aria-expanded", "true");
      panel.classList.add("is-open");
      // Measure with height temporarily freed so scrollHeight reflects the
      // panel's true natural size, not whatever it was clipped to.
      wrap.style.height = "auto";
      const target = wrap.scrollHeight;
      wrap.style.height = "0px";
      // Force a reflow so the browser commits the "0px" frame before the
      // next line changes it again — without this, some browsers collapse
      // both synchronous writes into one and skip the transition entirely,
      // jumping straight to the end state.
      void wrap.offsetHeight;
      wrap.style.height = `${target}px`;
      // Once the open transition finishes, drop back to `auto` so any
      // filter group opened/closed afterward is accommodated automatically
      // instead of being clipped by this now-stale snapshot.
      wrap.addEventListener("transitionend", function onOpen(event) {
        if (event.propertyName !== "height") return;
        wrap.removeEventListener("transitionend", onOpen);
        if (toggle.getAttribute("aria-expanded") === "true") wrap.style.height = "auto";
      });
    }
  });

  // Per-category accordions (Orientation/Category/Style/Holiday) — same
  // height-measuring transition pattern as the outer toggle above, applied
  // to every screen size (unlike the outer toggle, which only shows its
  // button <=900px). The markup always defaults every group to closed
  // (aria-expanded="false"); localStorage below overrides that default per
  // group so picking a filter (a full-page reload) doesn't reset whichever
  // group the shopper had open back to closed.
  var FILTER_GROUP_STORAGE_PREFIX = "collectionFilterGroupOpen:";

  panel.querySelectorAll("[data-filter-group]").forEach((group) => {
    const groupToggle = group.querySelector("[data-filter-group-toggle]");
    const groupWrap = group.querySelector("[data-filter-group-wrap]");
    if (!groupToggle || !groupWrap) return;
    const storageKey = FILTER_GROUP_STORAGE_PREFIX + group.dataset.filterGroup;
    if (localStorage.getItem(storageKey) === "true") {
      groupToggle.setAttribute("aria-expanded", "true");
      group.classList.add("is-open");
    }
    const startsOpen = groupToggle.getAttribute("aria-expanded") === "true";
    groupWrap.style.height = startsOpen ? `${groupWrap.scrollHeight}px` : "0px";

    groupToggle.addEventListener("click", () => {
      const isOpen = groupToggle.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        groupToggle.setAttribute("aria-expanded", "false");
        group.classList.remove("is-open");
        groupWrap.style.height = "0px";
        localStorage.setItem(storageKey, "false");
      } else {
        groupToggle.setAttribute("aria-expanded", "true");
        group.classList.add("is-open");
        groupWrap.style.height = "auto";
        const target = groupWrap.scrollHeight;
        groupWrap.style.height = "0px";
        void groupWrap.offsetHeight;
        groupWrap.style.height = `${target}px`;
        localStorage.setItem(storageKey, "true");
      }
    });
  });

  // Clearing every filter should also shut every accordion back to its
  // collapsed default, not just leave whichever groups were open sitting
  // open with nothing left inside them selected.
  var clearAllLink = panel.querySelector(".collection-filters__clear-all");
  if (clearAllLink) {
    clearAllLink.addEventListener("click", () => {
      panel.querySelectorAll("[data-filter-group]").forEach((group) => {
        localStorage.removeItem(FILTER_GROUP_STORAGE_PREFIX + group.dataset.filterGroup);
      });
    });
  }

  // Grid dimming is conditional on the grid existing (nothing to dim when a
  // filter combo already has zero results), but saving scroll position and
  // submitting the sort form must happen either way — nesting those inside
  // an `if (grid)` would silently drop the sort dropdown's submit entirely
  // whenever the current filter combo has no matches.
  var grid = document.querySelector(".product-grid");
  document.querySelectorAll(".collection-filters__link, .collection-filters__clear-all").forEach(function (link) {
    link.addEventListener("click", function () {
      sessionStorage.setItem(SCROLL_STORAGE_KEY, window.scrollY);
      if (grid) grid.classList.add("is-loading");
    });
  });

  var sortSelect = document.getElementById("CollectionSort");
  if (sortSelect) {
    sortSelect.addEventListener("change", function () {
      sessionStorage.setItem(SCROLL_STORAGE_KEY, window.scrollY);
      if (grid) grid.classList.add("is-loading");
      sortSelect.form.submit();
    });
  }
})();
